import { render, staticRenderFns } from "./GiftProductListMobile.vue?vue&type=template&id=0b9688bc"
import script from "./GiftProductListMobile.vue?vue&type=script&lang=js"
export * from "./GiftProductListMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports